"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSRBoundary = void 0;
var react_1 = __importDefault(require("react"));
var ssr_1 = require("../internal/helpers/ssr");
/**
 * Prevent rendering the children when it's rendered on the server. Optionally
 * render a fallback instead.
 */
function SSRBoundary(props) {
    var _a = props.fallback, fallback = _a === void 0 ? null : _a, children = props.children;
    if ((0, ssr_1.isServer)()) {
        if (fallback) {
            return react_1.default.createElement(react_1.default.Fragment, null, fallback);
        }
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.SSRBoundary = SSRBoundary;
